import { Fragment } from 'react';
import styled from 'styled-components';

import hourGlass2x from '@front/common/src/assets/images/hourglass@2x.png';
import hourGlass3x from '@front/common/src/assets/images/hourglass@3x.png';
import hourGlass from '@front/common/src/assets/images/hourglass.png';
import peaceWithHeart2x from '@front/common/src/assets/images/peace_with_heart@2x.png';
import peaceWithHeart3x from '@front/common/src/assets/images/peace_with_heart@3x.png';
import peaceWithHeart from '@front/common/src/assets/images/peace_with_heart.png';

import { translate } from '@front/i18n';

import Alert from '@front/web-ui/src/components/alert/alert';
import type { ImageProps } from '@front/web-ui/src/components/image/image';
import Modal, { ModalContent } from '@front/web-ui/src/components/modal/modal';
import Separator from '@front/web-ui/src/components/separator/separator';
import StickerItem from '@front/web-ui/src/components/sticker-item/sticker-item';
import { useIsMobile } from '@front/web-ui/src/styles/media-queries';

const t = translate('screens.instant_tax_credit_selection.what_is_tax_credit_modal');

type ImageItem = Pick<ImageProps, 'src' | 'double' | 'triple'> & { name: string };

const images: ImageItem[] = [
  {
    name: 'full_payment_refund_later',
    src: hourGlass,
    double: hourGlass2x,
    triple: hourGlass3x,
  },
  {
    name: 'easy_to_declare',
    src: peaceWithHeart,
    double: peaceWithHeart2x,
    triple: peaceWithHeart3x,
  },
];

const Column = styled.div<{ $hasSmallGap: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
  padding-top: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
`;

const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  margin-top: 20px;
`;

type WhatIsTaxCreditModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const WhatIsTaxCreditModal = ({ isOpen, onClose }: WhatIsTaxCreditModalProps) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      title={t('.title')}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        children: t('base.got_it'),
        onPress: onClose,
      }}
    >
      <StyledModalContent>
        <Column $hasSmallGap={isMobile}>
          {images.map(({ name, src, double, triple }) => (
            <Fragment key={name}>
              <StickerItem
                alt={t(`.items.${name}.image_alt`)}
                src={src}
                double={double}
                triple={triple}
                title={t(`.items.${name}.title`)}
                text={t(`.items.${name}.content`)}
              />
              <Separator />
            </Fragment>
          ))}
        </Column>
        <StyledAlert type='info' content={t('.alert')} />
      </StyledModalContent>
    </Modal>
  );
};

export default WhatIsTaxCreditModal;
